import { Component, OnInit } from '@angular/core';
import { PhonePipe } from '../../pipes/phone.pipe';
import { FaxPipe } from '../../pipes/fax.pipe';
import { AddressPipe } from '../../pipes/address.pipe';
import { NamePipe } from '../../pipes/name.pipe';
import { NgFor } from '@angular/common';
import { Handlers } from '../../classes/handlers';
import { IHandlers } from '../../interfaces/handlers';

@Component({
  selector: 'app-claim-handler',
  standalone: true,
  imports: [NgFor],
  templateUrl: './claim-handler.component.html',
  styleUrl: './claim-handler.component.css'
})
export class ClaimHandlerComponent implements OnInit {
  handlersArray: IHandlers[] = [];
  iHandlersInterface: IHandlers;

  constructor(private handlers: Handlers,
    private phonePipe: PhonePipe,
    private faxPipe: FaxPipe,
    private addressPipe: AddressPipe,
    private namePipe: NamePipe) { }

  ngOnInit(): void {

    const claimHandlersResponses = this.handlers.getHandlers()?.length ? this.handlers.getHandlers() : [{}]

    for (let handler of claimHandlersResponses) {

      this.iHandlersInterface = {
        type: handler.type ? handler.type : 'Not Available',
        subType: handler.sub_type ? handler.sub_type : 'Not Available',
        name: handler.name ? this.namePipe.transform(handler.name.first, handler.name.last) : 'Not Available',

        email: handler.email ? handler.email : 'Not Available',
        phone: handler.phone ? this.phonePipe.transform(handler.phone.number, handler.phone.areaCode, handler.phone.extension) : 'Not Available',
        fax: handler.fax ? this.faxPipe.transform(handler.fax.number, handler.fax.areaCode, handler.fax.extension)
          : 'Not Available',
        address: handler.mailing_address ? this.addressPipe.transform(handler.mailing_address.street,
          handler.mailing_address.city, handler.mailing_address.state, handler.mailing_address.zip_code,
          handler.mailing_address.addtl_info) : 'Not Available'
      }

      this.handlersArray.push(this.iHandlersInterface)
    }
  }

}
